import $ from 'zepto-webpack';
import './scss/index.scss'; 
import './js/broadCaster';
$(function () {
    $('#broadcaster').broadCaster();
    $("#mobile").on("click", function () {
        $("body").height("100%").css("overflow", "hidden");
        $(".cover").show();
        $(".ios-panel").show();
    });

    $(".hide").on("click", function () {
        $("body").height("auto").css("overflow", "auto");
        $(".cover").hide();
        $(".ios-panel").hide();
    });
    $('.version_and').text(window.v_ard);
    $('.version_ios').text(window.v_ios);
    $('.load_and').attr('href',window.link_ard);
    $('.load_ios').attr('href',window.link_ios);
    var html='';
    window.link_tf.map(item=>{
        html+=' <li class="item">'+
        '<a href="'+item+'" target="_blank">下载地址1</a>'+
        '</li>'
    })
    $('.load_tf').html(html);
    // var data = OpenInstall.parseUrlParams(); //openinstall.js中提供的工具函数，解析url中的所有查询参数
    // new OpenInstall({
    //     /*appKey必选参数，openinstall平台为每个应用分配的ID*/
    //     appKey: "fc4ndr",
    //     preferWakeup:true,
    //     onready: function () {
    //         var m = this;
    //         /*在app已安装的情况尝试拉起app*/
    //         m.schemeWakeup();
    //         /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
    //         $('.openinstall').click(function () { 
    //             m.wakeupOrInstall();
    //         })
    //     }
    // }, data);
})